import React from 'react'
import CalendarProvider from '../CalendarProvider'
import DayMapProvider from '../DayMapProvider'
import CalendarRoot from '../CalendarRoot'
import { ICalendarProps } from '../types'

/** @public */
function Calendar({ className, dayMap, renderDayFn, ...props }: ICalendarProps) {
  return (
    <CalendarProvider {...props}>
      <DayMapProvider dayMap={dayMap} renderDayFn={renderDayFn}>
        <CalendarRoot className={className} />
      </DayMapProvider>
    </CalendarProvider>
  )
}

export default Calendar
